// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, setAgGridLicense } from '../../shared/services/common-functions';
import { getFamiliesFactory, getLastWeeks } from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FamilyGroupAllocationToCapacityTable from './components/family-group-allocation-to-capacity-table';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFamilyGroupAllocationToCapacity } from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class FamilyGroupAllocationToCapacity extends Component {

    state = {

        familyTypes: [],
        lastWeeks: [],
        selectedFamilyType: '',
        selectedLastWeek: '',
        red: '',
        blue: '',
        submitRed: '',
        submitBlue: '',
        results: {}
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        this._isMounted = false;
        setAgGridLicense();

    }

    componentDidMount = () => {

        this._isMounted = true;

        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'Y' ).then( response => {

            if ( this._isMounted ) {
                this.setState( {
                    familyTypes: response
                } );
            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getLastWeeks().then( response => {

            if ( this._isMounted ) {
                this.setState( {
                    lastWeeks: response
                } );
            }
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.setState( {
            red: this.state.red === '' ? '100' : this.state.red,
            blue: this.state.blue === '' ? '0' : this.state.blue
        } );

    }

    componentWillUnmount = () => {

        this._isMounted = false;

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value
        }, () => {

            this.refresh();

        } );

    }

    handleColorChange () {

        const {
            submitBlue, submitRed, red, blue
        } = this.state;
        if ( submitRed !== red || submitBlue !== blue ) {

            this.refresh();

        }

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    handleWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedLastWeek ) {

            this.setState( {
                submitRed: this.state.red,
                submitBlue: this.state.blue
            } );

            this.props.increaseCounter();

            const { selectedFamilyType } = this.state;
            const selectedLastWeekObj = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) );
            
            if ( !selectedLastWeekObj ) {
                this.props.decreaseCounter();
                return;
            }
            
            const selectedLastWeekVal = selectedLastWeekObj.weekNumber;
            getFamilyGroupAllocationToCapacity( selectedFamilyType, selectedLastWeekVal )
                .then( response => {

                    if ( this._isMounted ) {
                        this.setState( {
                            results: response
                        } );
                    }
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            selectedFamilyType, selectedLastWeek, familyTypes,
            lastWeeks, red, blue, results
        } = this.state;

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Family and Group Capacity Allocation</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-family-group-allocation-to-capacity-top-options">
                            <div className="select-options">

                                <OptionsDropDown
                                    className="atp-family-group-allocation-to-capacity-select"
                                    label="Family"
                                    isLabelTranslated={false}
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={familyTypes}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamilyType}
                                />
                                <OptionsDropDown
                                    className="atp-family-group-allocation-to-capacity-select"
                                    label="Last Week"
                                    isLabelTranslated={false}
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />

                                {selectedFamilyType && selectedLastWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                            {selectedFamilyType && selectedLastWeek && (
                                <div className="export-button">

                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>

                                </div>
                            )}
                        </div>
                        <div className="label-options">
                            <LabeledInput
                                className="family-group-allocation-to-capacity-red-input"
                                name="red"
                                isEditable={true}
                                label="red: % > "
                                labelNeedsTranslation={false}
                                onChange={this.handleTextChange.bind( this, 'red' )}
                                onBlur={this.handleColorChange.bind( this )}
                                value={red}
                            />
                            <LabeledInput
                                className="family-group-allocation-to-capacity-blue-input"
                                name="blue"
                                isEditable={true}
                                label="blue: % < "
                                labelNeedsTranslation={false}
                                onChange={this.handleTextChange.bind( this, 'blue' )}
                                onBlur={this.handleColorChange.bind( this )}
                                value={blue}
                            />
                        </div>

                        {selectedFamilyType && selectedLastWeek && (
                            <FamilyGroupAllocationToCapacityTable
                                results={results}
                                unitCode={this.props.unit.name}
                                red={red}
                                blue={blue}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                                ref={this.child}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

FamilyGroupAllocationToCapacity.displayName = 'FamilyGroupAllocationToCapacity';
FamilyGroupAllocationToCapacity.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );

export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( FamilyGroupAllocationToCapacity ) );
